<script setup lang="ts">
import type { Component } from 'vue';

defineProps<{
  label: string;
  tone: string;
  icon: Component;
  badgeCount?: number;
}>();
</script>

<template>
  <button
    class="focus-ring relative flex min-h-28 w-full flex-col items-center justify-center gap-3 rounded-[28px] px-5 py-6 text-center text-2xl font-black shadow-soft transition hover:-translate-y-1 hover:scale-[1.01] active:scale-[0.98] md:min-h-36 md:text-3xl"
    :class="tone"
    type="button"
    :aria-label="label"
  >
    <span
      v-if="badgeCount && badgeCount > 0"
      class="absolute right-4 top-4 grid h-10 min-w-10 place-items-center rounded-full bg-heart-berry px-3 text-lg font-black text-white shadow-sm"
      aria-label="Ungelesene Briefe"
    >
      {{ badgeCount }}
    </span>
    <component :is="icon" class="h-10 w-10 md:h-12 md:w-12" aria-hidden="true" />
    <span>{{ label }}</span>
  </button>
</template>
